import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './Header'
import Hero from './Hero'
import Guidetails from './guidetails'
const App = () => {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path='/' element={<Hero />} />
          <Route exact path='/guidetails' element={<Guidetails/>} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App